import type { MenuItem } from './typing';

export const filterNonNullMenuItems = <MenuItemId extends string>(
    menuItem: MenuItem<MenuItemId> | null,
): menuItem is MenuItem<MenuItemId> => Boolean(menuItem);

export const sortMenuItemsByPosition = <MenuItemId extends string>(
    { position: firstMenuItemPosition }: MenuItem<MenuItemId>,
    { position: secondMenuItemPosition }: MenuItem<MenuItemId>,
): number => firstMenuItemPosition - secondMenuItemPosition;
